/* eslint-disable no-unused-vars */
import React from 'react';
import './App.css';
import "animate.css/animate.min.css";
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarC from './Components/NavbarC';
import Marquee from './Components/Marquee';
import Timelinie from './Components/Timelinie';
import Landing from './Components/Landing';
import DemoFooter from './Components/Footer';
import Brief from './Components/Brief';

function App() {
  return (
    <div>
      <NavbarC/>
      <Landing />
      <Brief />
      <Marquee />
      <Timelinie />
      <DemoFooter />
    </div >
  );
}
export default App;
